'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { faqs } from '@/data/homepage'

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section className="py-10 md:py-12 bg-[#f5f5f5]">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-6">
          <div className="text-[#b45309] font-semibold text-[11px] md:text-xs uppercase tracking-wider mb-1">
            SSS
          </div>
          <h2
            className="text-2xl md:text-3xl font-bold"
            style={{
              background: 'linear-gradient(to top right, #014b64, #01124d)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Sıkça Sorulan Sorular
          </h2>
        </div>

        <div className="max-w-2xl mx-auto space-y-2">
          {faqs.map((faq, index) => {
            const open = openIndex === index
            return (
              <div
                key={faq.question}
                className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
              >
                <button
                  type="button"
                  className="w-full px-4 py-3 text-left flex justify-between items-center gap-3 hover:bg-gray-50"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                >
                  <span className="font-semibold text-[#232f3e] text-sm">{faq.question}</span>
                  <ChevronDown
                    size={16}
                    className={`text-[#b45309] shrink-0 transition-transform ${
                      open ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    open ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="text-[#4b5563] text-xs leading-relaxed px-4 pb-3">{faq.answer}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
